import React, { useState, useEffect, useCallback } from 'react';

const Count = ({ targetDate }) => {
  const calculateTimeLeft = useCallback(() => {
    const difference = new Date(targetDate) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  }, [targetDate]);

  const [remainingTime, setRemainingTime] = useState(calculateTimeLeft());
  const countdownFinished = Object.keys(remainingTime).length === 0;

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime(calculateTimeLeft());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [calculateTimeLeft]);

  return (
    <div>
      {!countdownFinished && (
        <span style={{color: "#0ccbcb"}}>Days Left to Kippra Annual Conference</span>
      )}
      <div className="text-center flex flex-row justify-center">
        {remainingTime.days !== undefined && (
          <div className="frame mx-2">
            <span className="text-lg font-bold">
              {remainingTime.days} days
            </span>
          </div>
        )}
        {remainingTime.hours !== undefined && (
          <div className="frame mx-2">
            <span className="text-lg font-bold">
              {remainingTime.hours} hours
            </span>
          </div>
        )}
        {remainingTime.minutes !== undefined && (
          <div className="frame mx-2">
            <span className="text-lg font-bold">
              {remainingTime.minutes} minutes
            </span>
          </div>
        )}
        {remainingTime.seconds !== undefined && (
          <div className="frame mx-2">
            <span className="text-lg font-bold">
              {remainingTime.seconds} seconds
            </span>
          </div>
        )}
        {countdownFinished && (
          <span className="text-lg font-bold">
            Welcome to KIPPRA ANNUAL CONFERENCE
          </span>
        )}
      </div>
    </div>
  );
};

export default Count;
